import React, { Dispatch, SetStateAction } from 'react';
import { cx } from 'linaria';
import { UniqueOfferItemType, UniqueOfferModalType } from 'types/page-model';
import { Icon, RegularButton, Typography } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { withNbsp } from 'utils/with-nbsp';

import { DATA_QA_UNIQUE_OFFER_ITEM, DATA_QA_UNIQUE_OFFER_ITEM_TEXT } from './constants';
import {
  gridItem,
  uniqueOfferItemContainer,
  uniqueOfferItemImage,
  uniqueOfferItemText,
  uniqueOfferItemTextContainer,
} from './styles';

type UniqueOfferItemProps = {
  data: UniqueOfferItemType;
  setModalData: Dispatch<SetStateAction<UniqueOfferModalType | null>>;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
};

export const UniqueOfferItem: React.FC<UniqueOfferItemProps> = ({ data, setModalData, setModalOpen }) => {
  const { icon, text, modal } = data;

  return (
    <>
      <RegularButton
        data-qa={DATA_QA_UNIQUE_OFFER_ITEM}
        className={cx(gridItem, uniqueOfferItemContainer)}
        variant="secondary"
        onClick={(e) => {
          e.stopPropagation();
          setModalOpen(true);
          setModalData(modal);
        }}
      >
        {icon && (
          <ImagePlaceholder className={uniqueOfferItemImage} src={icon} alt="" width={34} height={29} />
        )}

        <div className={uniqueOfferItemTextContainer}>
          <Typography
            className={uniqueOfferItemText}
            color="text-primary"
            size="caption"
            variant="minor"
            data-qa={DATA_QA_UNIQUE_OFFER_ITEM_TEXT}
          >
            {withNbsp(text)}
          </Typography>
          <Icon size="space-200">
            <ChevronRightIcon size="l" strokeWidth={1.25} color="text-primary" />
          </Icon>
        </div>
      </RegularButton>
    </>
  );
};
